import { useState, useEffect } from "react";
import { Box, Grid, TextField } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DateComponent = ({
  setDate,
  setDisplayEndDate,
  SelectedStartDate,
  setSelectedStartDate,
  endDate,
  setEndDate,
  SelectedEndDate,
  setSelectedEndDate,
  startDateFormat,
  setstartDateFormat,
}) => {
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);

  // Convert to dayjs objects for MUI DatePicker
  const startDayjs = SelectedStartDate ? dayjs(SelectedStartDate) : null;
  const endDayjs = SelectedEndDate ? dayjs(SelectedEndDate) : null;

  // Handle start date change
  const datePickerOnChange = (val) => {
    const isoString = val ? val.toDate().toISOString() : "";
    setSelectedStartDate(val);
    setDate(isoString);
    setstartDateFormat(val ? val.format("YYYY-MM-DD") : "");
    setStartDateOpen(false);
    setEndDateOpen(true);
  };

  // Handle end date change
  const datePickerOnChangeEnd = (val) => {
    const isoString = val ? val.toDate().toISOString() : "";
    setSelectedEndDate(val);
    setDisplayEndDate(isoString);
    setEndDate(val ? val.format("YYYY-MM-DD") : "");
    setEndDateOpen(false);
  };

  useEffect(() => {
    // You can keep your data fetching logic here if needed
  }, [startDateFormat, endDate]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField
          label="Date"
          size="small"
          value={
            startDayjs && endDayjs
              ? `${startDayjs.format("DD-MM-YYYY")} to ${endDayjs.format(
                  "DD-MM-YYYY"
                )}`
              : startDayjs
              ? `${startDayjs.format("DD-MM-YYYY")}`
              : ""
          }
          placeholder="Select date range"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <CalendarMonthIcon
                sx={{
                  color: (theme) => theme.palette.primary.main,
                  cursor: "pointer",
                  mr: 1,
                }}
                onClick={() => setStartDateOpen(true)}
              />
            ),
            sx: {
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
              background: "#fff",
              borderRadius: 1,
              cursor: "pointer",
              border: "none",
              "& fieldset": { border: "none" },
            },
          }}
          onClick={() => setStartDateOpen(true)}
          sx={{ width: "100%" }}
        />

        <Box sx={{ position: "relative" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              open={startDateOpen}
              onOpen={() => setStartDateOpen(true)}
              onClose={() => setStartDateOpen(false)}
              value={startDayjs}
              onChange={datePickerOnChange}
              maxDate={endDayjs || undefined}
              slotProps={{
                popper: {
                  placement: "bottom-start",
                  anchorEl: document.querySelector(
                    'input[placeholder="Select date range"]'
                  ),
                  sx: { zIndex: 1500 },
                },
                textField: { style: { display: "none" } },
              }}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              open={endDateOpen}
              onOpen={() => setEndDateOpen(true)}
              onClose={() => setEndDateOpen(false)}
              value={endDayjs}
              onChange={datePickerOnChangeEnd}
              minDate={startDayjs || undefined}
              slotProps={{
                popper: {
                  placement: "bottom-start",
                  anchorEl: document.querySelector(
                    'input[placeholder="Select date range"]'
                  ),
                  sx: { zIndex: 1500 },
                },
                textField: { style: { display: "none" } },
              }}
            />
          </LocalizationProvider>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DateComponent;
